import { SIDEBAR_ELEMENT_ID } from 'app/shared/templates/SplitMapTemplate/constants';
import routeUtils from 'app/shared/utils/routeUtils';

const BDP_SCROLL_KEY = 'hp-bdp-scroll-position';

// Monotonic counter incremented by clearBdpScroll(). BuildingHdp captures the value
// on mount and passes it to saveBdpScroll on unmount. If the counter changed (a clear
// happened during the component's lifetime), the save is skipped. Deterministic — no
// timing assumptions.
let _clearGeneration = 0;

export function getClearGeneration(): number {
  return _clearGeneration;
}

export function saveBdpScroll(buildingPathname: string, generation: number): void {
  if (_clearGeneration !== generation) return;
  try {
    const sidebar = document.getElementById(SIDEBAR_ELEMENT_ID);
    const data = {
      maloneLotId: routeUtils.getMaloneLotIdEncodedFromUrl(buildingPathname),
      windowY: window.scrollY,
      sidebarTop: sidebar ? sidebar.scrollTop : 0,
    };
    sessionStorage.setItem(BDP_SCROLL_KEY, JSON.stringify(data));
  } catch {
    // sessionStorage unavailable
  }
}

export function restoreBdpScroll(buildingPathname: string): void {
  try {
    const raw = sessionStorage.getItem(BDP_SCROLL_KEY);
    if (!raw) return;
    const data = JSON.parse(raw);
    sessionStorage.removeItem(BDP_SCROLL_KEY);

    const currentId = routeUtils.getMaloneLotIdEncodedFromUrl(buildingPathname);
    if (data.maloneLotId !== currentId) return;

    const { windowY, sidebarTop } = data;
    requestAnimationFrame(() => {
      if (windowY > 0) {
        window.scrollTo(0, windowY);
      }
      if (sidebarTop > 0) {
        const sidebar = document.getElementById(SIDEBAR_ELEMENT_ID);
        if (sidebar) {
          sidebar.scrollTop = sidebarTop;
        }
      }
    });
  } catch {
    // sessionStorage unavailable or malformed
  }
}

export function clearBdpScroll(): void {
  _clearGeneration++;
  try {
    sessionStorage.removeItem(BDP_SCROLL_KEY);
  } catch {
    // sessionStorage unavailable
  }
}

export function hasBdpScrollFor(uriBuilding: string | undefined): boolean {
  if (!uriBuilding) return false;
  try {
    const raw = sessionStorage.getItem(BDP_SCROLL_KEY);
    if (!raw) return false;
    const data = JSON.parse(raw);
    return data.maloneLotId === routeUtils.getMaloneLotIdEncodedFromUrl(uriBuilding);
  } catch {
    return false;
  }
}
